<template>
  <div class="invoice_mini">
    <app-info :order="order" />
    <table class="table">
      <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
        >
          <td>
            <div cols="12">
              {{ item.name | capitalize }}
              <small class="sml-text">
                <template v-if="item.imei">
                  <br>IMEI: {{ item.imei }}
                </template>
                <template v-if="item.sNumber">
                  <br>
                  SN: {{ item.sNumber }}
                </template>
              </small>
            </div>
            <div
              cols="12"
              class="text-right"
            >
              <span class="mini-text">
                ({{ item.discount }}% off) {{ item.qty }} X
                {{ item.price }} =</span>
              {{ item.subTotal }}
              <span v-if="billing.billItemUnit">{{
                item.data.unitOfMeasure | lowercase
              }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-right">
            Total ({{ order.totalItems }}
            {{ order.totalItems | pluralize(["item", "items"]) }}) :
            {{ order.subTotal | currency }}
          </td>
        </tr>
        <tr>
          <td class="text-right">
            <h5 v-if="order.shippingRecipient">
              Shipping :
              {{ order.shippingAmount | currency }}
            </h5>
            <h5>
              Tax (+ {{ order.taxRate }} %) : {{ order.taxAmount | currency }}
            </h5>
            <h5>
              Discount (- {{ order.discountRate }} %) :
              {{ order.discountedAmount | currency }}
            </h5>

            <h4>
              {{ order.totalAmount | currency }}
            </h4>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="order.printNote">
      <hr>
      <strong>{{ order.noteTitle }}:</strong>
      <p class="term">
        {{ order.saleNote }}
      </p>
    </template>
    <terms-conditions />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Terms from "../common/Terms.vue";
import AppInfo from "../common/ComInfo.vue";
export default {
  components: {
    "terms-conditions": Terms,
    "app-info": AppInfo,
  },
  data() {
    return {
      items: {},
      order: {},
      payment: {},
    };
  },
  computed: {
    ...mapGetters({
      info: "misc/currentSale",
      billing: "configs/billing",
    }),
  },
  mounted() {
    this.getFromApi();
    Event.$emit("printSize");
    Event.$emit("loadTerms", "saleTerms");
  },
  methods: {
    active() {
      let id = this.info;
      if (this.$route.params.id) {
        id = this.$route.params.id;
      }
      return id;
    },
    getFromApi() {
      window.axios.get("/order/" + this.active()).then((response) => {
        this.$data.items = response.data.order.items;
        this.$data.order = response.data.order;
        this.$data.payment = response.data.payment;
        setTimeout(() => {
          window.print();
        }, 500);
      });
    },
  },
};
</script>
